export const routes = {
  home: '/',
  services: '/services',
  news: '/news',
  partners: '/partners',
  support: '/support',
  my: '/my',
  intro: '/intro',
};

export const navItems = [
  { id: 'home', path: routes.home, label: '홈', icon: 'home', authRequired: false },
  { id: 'services', path: routes.services, label: '서비스', icon: 'grid', authRequired: false },
  { id: 'news', path: routes.news, label: '말타뉴스', icon: 'notice', authRequired: false },
  { id: 'partners', path: routes.partners, label: '말타파트너스', icon: 'partner', authRequired: false },
  { id: 'support', path: routes.support, label: '고객센터', icon: 'support', authRequired: false },
  { id: 'my', path: routes.my, label: '내 공간', icon: 'user', authRequired: true },
];

export const mobileNavItems = navItems.filter((item) =>
  ['home', 'services', 'news', 'my'].includes(item.id),
);

export const routeMap = navItems.reduce(
  (map, item) => ({
    ...map,
    [item.path]: item,
  }),
  {},
);

export const routeAliases = {
  '/notice': routes.news,
};

export const supportedRoutes = new Set([...navItems.map((item) => item.path), routes.intro]);
